import { PaidWithdrawModel, WithdrawStatusTitles } from '@/features/withdraws'
import { formatCurrency } from '@/shared/lib/currency'
import { formatDate } from '@/shared/lib/date'
import { formatRequisite } from '@/shared/lib/requisite/formatRequisite'
import { getShortenId } from '@/shared/utils/getShortenId'
import { ColumnDef } from '@tanstack/react-table'
import { Link } from 'react-router-dom'
import { CopyBlock } from '@/shared/components/CopyBlock/CopyBlock'

export const withdrawsPaidColumns: ColumnDef<PaidWithdrawModel>[] = [
  {
    accessorKey: 'id',
    header: () => <div>ID заявки</div>,
    cell: ({ row }) => {
      const id = row.getValue<string>('id')
      return (
        <CopyBlock text={id} title={id}>
          <Link to={`/payout/${id}`} className="text-primary">
            {getShortenId(id)}
          </Link>
        </CopyBlock>
      )
    },
  },
  {
    accessorKey: 'date',
    header: 'Дата и время',
    cell: ({ row }) => {
      return (
        <span className="font-medium text-sm whitespace-nowrap">
          {formatDate(row.original.confirmedByTraderAt, 'dateShortAndTimeWithoutSec')}
        </span>
      )
    },
  },
  {
    accessorKey: 'amount',
    header: 'Сумма',
    cell: ({ row }) => {
      return (
        <div className="flex flex-col whitespace-nowrap">
          {!row.original.factAmountTo ||
          row.original.amountTo.toFixed(2) === row.original.factAmountTo.toFixed(2) ? (
            <CopyBlock text={row.original.amountTo?.toFixed(2)}>
              {formatCurrency(row.original.amountTo ?? 0, row.original.currencyTo)}
            </CopyBlock>
          ) : (
            <CopyBlock text={row.original.factAmountTo?.toFixed(2)}>
              {formatCurrency(row.original.factAmountTo ?? 0, row.original.currencyTo)}
            </CopyBlock>
          )}
          <CopyBlock text={row.original.traderAmountFrom.toFixed(2)} color="secondary">
            {formatCurrency(row.original.traderAmountFrom, row.original.currencyFrom)}
          </CopyBlock>
        </div>
      )
    },
  },
  {
    accessorKey: 'requisite',
    header: 'Реквизит',
    cell: ({ row }) => {
      return (
        <CopyBlock text={row.original.paymentRequisitValue}>
          {formatRequisite(row.original.paymentRequisitValue)}
        </CopyBlock>
      )
    },
  },
  {
    accessorKey: 'status',
    header: 'Статус',
    cell: ({ row }) => {
      const status = row.original.withdrawStatus
      const title = WithdrawStatusTitles[status]
      return <span className="font-medium text-sm">{title}</span>
    },
  },
]
